<template>
<div class="homepage">
    <FilterDatas 
      v-show="false"
      :collection="collection" 
      :mode="'prod'" 
      :model="['id', 'firstname', 'lastname', 'beaconId', 'tags']"
      :setQuery="queryFromSidebar"
      @filteredData="filteredLogs">
    </FilterDatas>
    
    <el-dialog
      class="custom-modal-size"
      title="Filter"
      width="1100px"
      :visible.sync="getFilterModalVisible">
      <FilterDatas 
        :collection="collection" 
        :mode="'prod'" 
        :model="['id', 'firstname', 'lastname', 'beaconId', 'tags']"
        :setQuery="queryFromSidebar"
        @filteredData="filteredLogs"></FilterDatas>
      <el-button @click="closeFilterModal">Fermer</el-button>
    </el-dialog>

    <el-card class="custom-margin-bottom ">
      <TopBarMiniCard
        :title="'Beacons'"
        :cardLoaded="collection.length"
        :isLoaded="'isAllBeaconsLoaded'"
        @clickLoadMore="loadMoreData"
        @refresh="refreshData"
        @createNew="createNew"
      ></TopBarMiniCard>
    </el-card>
    <CardMiniBeacon v-for="(beacon, idx) in filteredCollection" :key="idx" :beacon="beacon"></CardMiniBeacon>
    
    <!-- start Modal for Create beacon form -->
    <el-dialog
      width="1200px"
      :visible.sync="dialogFormVisible"
      :modalAppendToBody="false">
        <CreateBeaconModal :key="dialogFormVisible" @closeForm="closeCreationForm"></CreateBeaconModal>
    </el-dialog>
    <!-- end Modal for Create beacon form -->
  </div>
</template>

<script>
import CardMiniBeacon from '@/components/CardMiniBeacon.vue'
import TopBarMiniCard from '../components/TopBarMiniCard.vue'
import FilterDatas from '@/components/vuejs-components-collection/components-collection/FilterDatas.vue'
import CreateBeaconModal from '../components/beacon/CreateBeaconModal.vue'

export default {
  name: 'productionArea',
  components: {
    FilterDatas,
    CardMiniBeacon,
    TopBarMiniCard,
    CreateBeaconModal
  },
  data() {
    return {
      filteredCollection: [],
      dialogFormVisible: false
    }
  },
  mounted() {
    if(this.$store.getters.beacons.length === 0) {
      this.$store.dispatch('getOperators');
    }
    if(this.$store.getters.productionZones.length === 0) {
      this.$store.dispatch('getProductionZones');
    }
    if(this.$store.getters.manufacturingOrders.length === 0) {
      this.$store.dispatch('getManufacturingOrders');
    }
  },
  created() {
    this.filteredCollection = this.collection;
  },
  watch: {
    collection: function() {
      this.filteredCollection = this.collection;
    }
  },
  computed : {
    collection() {
      return this.$store.getters.beacons
    },
    allLoaded() {
      return this.$store.getters.isAllBeaconsLoaded;
    },
    getFilterModalVisible: {
      get: function() {
        return this.$store.getters.getFilterModalVisible;
      },
      set: function() {
        return this.$store.dispatch('switchFilterModalVisible', false);
      }
    },
    queryFromSidebar() {
      return this.$store.getters.searchFavSelected;
    }
  },
  methods: {
    filteredLogs: function(event) {
      this.filteredCollection = event;
    },
    loadMoreData: function() {
      this.$store.dispatch('loadMoreBeacons');
    },
    refreshData: function() {
      this.$store.dispatch('refreshBeacons');
    },
    closeFilterModal: function() {
      this.$store.dispatch('switchFilterModalVisible');
    },
    createNew: function() {
      this.dialogFormVisible = true;
    },
    closeCreationForm: function() {
      this.dialogFormVisible = false;
    }
  }
}
</script>

<style lang="css" scoped>
  .homepage {
    min-width: 950px;
  }

  .custom-modal-size {
    margin: auto;
  }

  .custom-margin-bottom {
    margin-bottom: 20px;
  }

  .el-dialog {
    width: 1100px !important;
  }

</style>
